<template>
    <v-container fluid>
        <v-row align="center" justify="center" class="my-6">
            <v-col cols="12">
                <ProfileHeader :user="user"/>
            </v-col>

            <v-col cols="12">
                <UserDataForm :user="user"/>
            </v-col>

            <v-col cols="12" class="text-center my-6 py-6">
                <v-btn color="error" outlined rounded @click="logOut">
                    <v-icon left>mdi-power</v-icon>
                    {{ $t("components.UserAccount.LogoutLabel") }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';
import EventBus from '@/utils/EventBus';

import ProfileHeader from '@/components/profile/ProfileHeader';
import UserDataForm from '@/components/profile/UserDataForm';


/**
 * Profile contains the user profile information and the forms to change that 
 * information like password or name.
 */
export default {
    name: 'Profile',
    data: () => ({
        user: {
            name: "",
            email: ""
        }
    }),
    async mounted() {
        await this.updateUser();
        EventBus.$on("userUpdated", async () => {
            await this.updateUser();
        });
    },
    methods: {
        async updateUser() {
            const [ success, user ] = await AuthAPI.currentUser();
            if (!success) this.$router.push({ name: 'login' });
            this.user = user.attributes;
            this.user.isAdmin = user.isAdmin;
            this.name = this.user.name;
        },
        async logOut() {
            const [ success, error ] = await AuthAPI.logOut();
            if (!success) EventBus.$emit("popup", error.message);
            else EventBus.$emit("popup", `Goodbye!`);
            this.$router.push({ name: 'login' });
        }
    },
    components: {
        ProfileHeader, UserDataForm
    }
}
</script>